export const siteInfo = {
  name: '看料社',
  slogan: '娱乐热点追踪 · 重要节点不错过',
  intro:
    '看料社是一个专注娱乐热点与网络话题的内容站点。我们不急着下结论，而是把一条线索拆成可追溯的时间线，持续跟进最新动态与事件进展。',
  email: 'contact@kanliaoshe-mail.com',
  workingHours: '周一至周五 10:00 - 18:00',
  since: '2024',
};

export const navItems = [
  { label: '首页', path: '/' },
  { label: '全部追踪', path: '/tracking' },
  { label: '关于我们', path: '/about' },
];

export const tickerItems = [
  '年度户外音乐节首批阵容官宣，剩余名单分两批公布',
  '《长安夜行》完成勘景，进入集中拍摄阶段',
  '老牌综艺改版首轮录制结束，剪辑版本待调整',
  '直播连麦后续：平台上线内容提示机制',
  '巡演退票窗口缩短至三天，购票前请注意规则',
];

export const stats = [
  { value: '320+', label: '在追线索' },
  { value: '1,860', label: '累计更新节点' },
  { value: '99%', label: '来源可追溯' },
  { value: '每日', label: '跟进频率' },
];